import React from 'react';
import './PreHeader.css';
import { Show } from '@clerk/react';

function PreHeader() {
  return (
    <div className="preheader">
    <Show when="signed-in">
      <a href="/dashboard" className="signIn-btn">Dashboard</a>  
    </Show>
    <Show when="signed-out">
      <a href="/dashboard" className="signIn-btn">Sign In</a>
    </Show>
    </div>
  );
}

export default PreHeader;
